import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { DefaultMoneyInput } from "../../../../../../common/components/default_money_input";

/**
 * Header ContasPagar Lista.
 * 
 */
type Props = {
  ddlCentroCusto: CentroCustoDropDown[];
  ddlBanco: DropDown[];
  ddlOrdemCompra: DropDown[];
  ddlSubconta: DropDown[];
  ddlFornecedor: DropDown[];
  ddlFuncionario: DropDown[];
  ddlProdutoServico: DropDown[];
  ddlNroMedicao: DropDown[];

  selectedIdsCentroCusto?: number[];
  selectedIdsCliente?: number[];
  selectedIdsBanco?: number[];
  selectedIdsOrdemCompra?: number[];
  selectedIdsSubconta?: number[];

  selectedIdsFornecedor?: number[];
  selectedIdsFuncionario?: number[];
  selectedIdsFuncionarioPago?: number[];
  selectedIdsProdutoServico?: number[];
  selectedIdsNroMedicao?: number[];

  status?: number | null;
  titulo?: string | null;
  dataPagarDe?: Date | null;
  dataPagarAte?: Date | null;
  dataPagoDe?: Date | null;
  dataPagoAte?: Date | null;
  dataCriacaoDe?: Date | null;
  dataCriacaoAte?: Date | null;
  idContratoFinanceiro?: number | null;

  valor?: number | null;
  nrContasPagar?: number | null;
  nrNotaFiscal?: string | null;
  nrNotaFiscalEspecial?: string | null;
  formaPagamento?: string | null;

  onClearFilters: () => void;
  onStatusChange: (novoStatus: number) => void;
  handleIdCentroCustoChange: (v: number[]) => void;
  handleIdClienteChange?: (v: number[]) => void;
  handleIdBancoChange: (v: number[]) => void;
  handleIdOrdemCompraChange: (v: number[]) => void;
  handleIdSubcontaChange: (v: number[]) => void;

  handleIdFornecedorChange: (v: number[]) => void;
  handleIdFuncionarioChange: (v: number[]) => void;
  handleIdFuncionarioPagoChange: (v: number[]) => void;
  handleIdProdutoServicoChange: (v: number[]) => void;
  handleIdNroMedicaoChange: (v: number[]) => void;

  handleIdContratoFinanceiroChange?: (v: string | null) => void;
  handleTituloChange: (v: string | null) => void;
  handleDataPagarRangeChange: (v: Date | null, x: Date | null) => void;
  handleDataPagoRangeChange: (v: Date | null, x: Date | null) => void;
  handleDataCriacaoRangeChange: (v: Date | null, x: Date | null) => void;

  handleValorChange: (e: number | null) => void;
  handleNrContaChange: (e: string | null) => void;
  handleNotaFiscalChange: (v: string | null) => void;
  handleNotaFiscalEspecialChange: (v: string | null) => void;
  handleFormaPagamentoChange: (v: string | null) => void;
};

export const Header = ({
  ddlCentroCusto,
  ddlBanco,
  ddlOrdemCompra,
  ddlSubconta,
  ddlFornecedor,
  ddlFuncionario,
  ddlProdutoServico,
  ddlNroMedicao,

  selectedIdsCentroCusto = [],
  selectedIdsBanco = [],
  selectedIdsOrdemCompra = [],
  selectedIdsSubconta = [],
  selectedIdsFornecedor = [],
  selectedIdsFuncionario = [],
  selectedIdsProdutoServico = [],
  selectedIdsNroMedicao = [],
  selectedIdsFuncionarioPago = [],
  status,

  titulo,
  valor,
  nrContasPagar,
  nrNotaFiscal,
  nrNotaFiscalEspecial,
  formaPagamento,

  dataPagarDe,
  dataPagarAte,
  dataPagoDe,
  dataPagoAte,
  dataCriacaoDe,
  dataCriacaoAte,

  onClearFilters,
  onStatusChange,
  handleIdCentroCustoChange,
  handleIdBancoChange,
  handleIdOrdemCompraChange,
  handleIdSubcontaChange,
  handleIdFornecedorChange,
  handleIdFuncionarioChange,
  handleIdFuncionarioPagoChange,
  handleIdProdutoServicoChange,
  handleIdNroMedicaoChange,
  handleTituloChange,
  handleDataPagarRangeChange,
  handleDataPagoRangeChange,
  handleDataCriacaoRangeChange,
  handleValorChange,
  handleNrContaChange,
  handleNotaFiscalChange,
  handleNotaFiscalEspecialChange,
  handleFormaPagamentoChange,
}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Centro de Custo'
                  value={ddlCentroCusto.filter(x => selectedIdsCentroCusto?.includes(x.id))}
                  options={ddlCentroCusto}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdCentroCustoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Subconta'
                  value={ddlSubconta.filter(x => selectedIdsSubconta?.includes(x.id))}
                  options={ddlSubconta}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdSubcontaChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <DefaultInput
                  name='titulo'
                  label='Titulo/Pedido'
                  readOnly={false}
                  value={titulo}
                  onChangeValue={handleTituloChange} />
              </div>

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Funcionário Responsável'
                  value={ddlFuncionario.filter(x => selectedIdsFuncionario?.includes(x.id))}
                  options={ddlFuncionario}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdFuncionarioChange(x?.map(y => y.id) ?? [])} />
              </div>

            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-full">
                <DefaultDateRangePickerInput
                  label='Data Pagar'
                  dataDe={dataPagarDe ?? null}
                  dataAte={dataPagarAte ?? null}
                  onChange={async (start, end) => {
                    handleDataPagarRangeChange(start, end)
                  }}
                />
              </div>

              <div className="w-full">
                <DefaultDateRangePickerInput
                  label='Data pago'
                  dataDe={dataPagoDe ?? null}
                  dataAte={dataPagoAte ?? null}
                  onChange={async (start, end) => {
                    handleDataPagoRangeChange(start, end)
                  }}
                />
              </div>

              <div className="w-full">
                <DefaultDateRangePickerInput
                  label='Data Criação'
                  dataDe={dataCriacaoDe ?? null}
                  dataAte={dataCriacaoAte ?? null}
                  onChange={async (start, end) => {
                    handleDataCriacaoRangeChange(start, end)
                  }}
                />
              </div>



            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-[40%]">
                <DefaultMultiAutocomplete
                  label='Banco'
                  value={ddlBanco.filter(x => selectedIdsBanco?.includes(x.id))}
                  options={ddlBanco}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdBancoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-[40%]">
                <DefaultMultiAutocomplete
                  label='Fornecedor'
                  value={ddlFornecedor.filter(x => selectedIdsFornecedor?.includes(x.id))}
                  options={ddlFornecedor}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdFornecedorChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-[40%]">
                <DefaultMultiAutocomplete
                  label='Funcionário Folha'
                  value={ddlFuncionario.filter(x => selectedIdsFuncionarioPago?.includes(x.id))}
                  options={ddlFuncionario}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdFuncionarioPagoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-[40%]">
                <DefaultMultiAutocomplete
                  label='Produto/Serviço'
                  value={ddlProdutoServico.filter(x => selectedIdsProdutoServico?.includes(x.id))}
                  options={ddlProdutoServico}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdProdutoServicoChange(x?.map(y => y.id) ?? [])} />
              </div>

            </div>


            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Número Medição'
                  value={ddlNroMedicao.filter(x => selectedIdsNroMedicao?.includes(x.id))}
                  options={ddlNroMedicao}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdNroMedicaoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <DefaultInput
                  name='notaFiscal'
                  label='Nota Fiscal'
                  readOnly={false}
                  value={nrNotaFiscal}
                  onChangeValue={handleNotaFiscalChange} />

              </div>

              <div className="w-full">
                <DefaultInput
                  name='notaFiscalEspecial'
                  label='Nota Fiscal Especial'
                  readOnly={false}
                  value={nrNotaFiscalEspecial}
                  onChangeValue={handleNotaFiscalEspecialChange} />
              </div>

              <div className="w-[40%]">
                <MaskedInput
                  name={'nrConta'}
                  label={'Nro da Conta'}
                  mask="00000000"
                  maskPlaceholder="________"
                  value={nrContasPagar?.toString() ?? null}
                  onChange={handleNrContaChange}
                />
              </div>



            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-[30%]">
                <FormControl size="small" fullWidth>
                  <InputLabel id="modulo-dashboard"></InputLabel>
                  <Select
                    labelId="modulo-dashboard"
                    value={status ?? 4}
                    onChange={handleStatusChange}>
                    <MenuItem value={4}>Todas as contas</MenuItem>
                    <MenuItem value={0}>Em aberto</MenuItem>
                    <MenuItem value={1}>Pagas</MenuItem>
                    <MenuItem value={2}>Outros</MenuItem>
                    <MenuItem value={3}>Atrasadas</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <div className="w-[70%]">
                <DefaultInput
                  name='formaPagamento'
                  label='Forma de Pagamento'
                  readOnly={false}
                  value={formaPagamento}
                  onChangeValue={handleFormaPagamentoChange} />
              </div>

              <div className="w-[40%]">
                <DefaultMultiAutocomplete
                  label='Ordem Compra'
                  value={ddlOrdemCompra.filter(x => selectedIdsOrdemCompra?.includes(x.id))}
                  options={ddlOrdemCompra}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdOrdemCompraChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-[40%]">
                <DefaultMoneyInput
                  name='Valor'
                  label='Valor'
                  value={valor ?? null}
                  onChangeValue={handleValorChange}
                />
              </div>

            </div>




            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}